import { render } from "./TableOrderPage.vue?vue&type=template&id=653137f2"
import script from "./TableOrderPage.vue?vue&type=script&lang=js"
export * from "./TableOrderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__